/**
 * Shared classes for an async-action button. The rainbow loading ring is the
 * busy cue — `busy` NEVER greys the button (the ring is the signal). Grey is
 * reserved for a genuinely disabled control, and globals.css keys it on
 * `.rainbow-ring:disabled` minus busy — subtle text on the hairline grey,
 * whatever colour the variant carries — so a `<fieldset disabled>` greys a
 * pill exactly like the attribute does. Used by both {@link SubmitButton}
 * and the office {@link Button} so the busy/disabled treatment lives in one
 * place.
 */
export function rainbowRingClass({
  solid = false,
  busy = false,
  disabled = false,
}: {
  /** Filled-pill variant: the ring rides over a solid bg. */
  solid?: boolean;
  /** Action in flight — show the running ring, keep full opacity. */
  busy?: boolean;
  /** Genuinely disabled (a reason OTHER than busy) — grey it out. */
  disabled?: boolean;
}): string {
  return [
    "rainbow-ring",
    solid && "rainbow-ring-solid",
    busy
      ? "rainbow-ring-busy cursor-progress"
      : disabled
        ? "cursor-not-allowed"
        : "cursor-pointer",
  ]
    .filter(Boolean)
    .join(" ");
}
